import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { BaseQueryFn } from "@reduxjs/toolkit/dist/query";
import { snackWrapper } from "helpers";

const { REACT_APP_PORT, REACT_APP_HOST } = process.env;

const host = (window as any)?._env_?.REACT_APP_HOST ? (window as any)?._env_?.REACT_APP_HOST : window.location.hostname;

const baseURLFromWindow = (window as any)?._env_?.REACT_APP_PORT && host + ":" + (window as any)._env_.REACT_APP_PORT;
const baseURLFromENV = (REACT_APP_HOST as string) + ":" + REACT_APP_PORT;

export const baseURL = baseURLFromWindow || baseURLFromENV;

export const $api = axios.create({
	baseURL,
	withCredentials: true,
});

$api.interceptors.request.use((config: any) => {
	// config.headers.Authorization = `Bearer ${reduxToken}`;
	config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
	return config;
});
$api.interceptors.response.use(
	(r) => r,
	async (error) => {
		const config = error.config;
		if (error) {
			if (!error.response) {
				return console.log("здесь ошибка", error.message);
			}
			// if (config.retry) {
			// 	await Promise.reject(error);
			// }
			const status = error.response.status;
			if (status === 500) {
				snackWrapper("error", "На сервере произошла ошибка, запрос не может быть обработан");
			}
			if (status === 403) {
				if (typeof error.response.data === "string" && error.response.data) snackWrapper("error", error.response.data);
			}
			await Promise.reject(error);

			return { config, retry: false };
		}
	},
);
// export const axiosBaseQuery =
// 	(): BaseQueryFn<
// 		{
// 			url: string;
// 			method?: AxiosRequestConfig["method"];
// 			data?: AxiosRequestConfig["data"];
// 			params?: AxiosRequestConfig["params"];
// 		},
// 		unknown,
// 		unknown
// 	> =>
// 	async ({ url, method = "GET", data, params }) => {
// 		try {
// 			const result = await $api({ url, method, data, params });
// 			return { data: result.data };
// 		} catch (axiosError) {
// 			let err = axiosError as AxiosError;
// 			return {
// 				error: {
// 					status: err.response?.status,
// 					data: err.response?.data || err.message,
// 				},
// 			};
// 		}
// 	};

// Определение конфигурации для baseQuery
type AxiosBaseQueryConfig = {
	axiosConfig?: AxiosRequestConfig;
};

// Определение типа ответа
type AxiosBaseQueryResult<TData> = { data: TData } | { error: AxiosError };

// Создание функции для baseQuery
export const axiosBaseQuery =
	({ axiosConfig }: AxiosBaseQueryConfig = {}): BaseQueryFn<AxiosRequestConfig, AxiosBaseQueryResult<unknown>> =>
	async ({ url, method = "GET", params, data }) => {
		try {
			const response: AxiosResponse = await $api({
				url,
				method,
				params,
				data,
				...axiosConfig,
			});

			// Возвращаем объект, содержащий полученные данные
			return { data: response.data };
		} catch (error: unknown) {
			const axiosError = error as AxiosError;

			// Формируем объект ошибки
			const errorObject = {
				status: axiosError.response?.status ?? 0,
				data: axiosError.response?.data ?? null,
				error: axiosError,
			};

			// Возвращаем объект ошибки
			return { error: errorObject };
		}
	};
